<template>
  <v-container fluid class="pa-0 col-12 justify-center ebay-shipping-page">
    <!--TOOLBAR-->
    <div
      class="ebay-shipping-toolbar bg-red-darken-3 text-white px-3 py-2 py-md-3 px-md-6 px-lg-8"
    >
      <div class="text-subtitle-1 ebay-shipping-toolbar-title">
        {{ $t("leko_employees.ebay_shipping_price.label") }}
      </div>
    </div>

    <div class="col-12 text-center justify-center ebay-shipping-content">
      <v-row>
        <v-col cols="12">
          <v-card flat>
            <v-row class="flex-wrap ma-0">
              <v-col cols="12" lg="8">
                <v-container class="ebay-shipping-form">
                  <!-- PART DESCRIPTION -->
                  <v-toolbar theme="dark">
                    <v-toolbar-title>
                      {{
                        $t(
                          "leko_employees.ebay_shipping_price.part_description",
                        )
                      }}
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-row class="mb-2 align-center justify-center flex-wrap">
                    <v-col cols="12" sm="7" md="8">
                      <v-autocomplete
                        v-model="title"
                        v-model:search="searchTitle"
                        v-model:menu="menuOpen"
                        :loading="loadingTitle"
                        :items="titles"
                        :label="$t('parts.inventory.search')"
                        :item-title="() => ''"
                        :custom-filter="customFilter"
                        variant="outlined"
                        color="grey-darken-4"
                        append-inner-icon="mdi-magnify"
                        single-line
                        hide-details
                        hide-no-data
                        clearable
                        autocomplete="off"
                        @update:search="updateSearch"
                      >
                        <template #item="{ item, props }">
                          <v-list-item
                            v-bind="props"
                            class="listRowColor"
                            @click="selectCode(item)"
                          >
                            <span
                              class="font-weight-bold"
                              v-html="
                                highlight(
                                  item?.raw?.title?.[$store.getters.language] ||
                                    'No Title',
                                  searchTitle,
                                )
                              "
                            />
                          </v-list-item>
                        </template>
                        <template #selection="{ item }">
                          <span v-if="item">
                            {{ item?.raw?.title?.[$store.getters.language] }}
                          </span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="5" md="4">
                      <v-text-field
                        v-model="price"
                        type="number"
                        :label="$t('ebayShippingReferencePrice')"
                        color="red-darken-1"
                        :class="{ 'mt-4': $vuetify.display.smAndUp }"
                        variant="outlined"
                      />
                    </v-col>
                    <v-col v-if="title" cols="12" sm="6">
                      <v-text-field
                        v-model="title.ebayCode"
                        type="number"
                        :label="$t('ebayCode')"
                        color="red-darken-1"
                        :class="{ 'mt-3': $vuetify.display.smAndUp }"
                      />
                    </v-col>
                    <v-col v-if="title" cols="12" sm="6">
                      <v-text-field
                        v-model="category"
                        variant="outlined"
                        :label="$t('ebayCategory')"
                        :hint="$t('ebayCategory')"
                        color="red-darken-1"
                        :class="{ 'mt-3': $vuetify.display.smAndUp }"
                      />
                    </v-col>

                    <v-col cols="12">
                      <div class="d-flex justify-end">
                        <v-btn
                          :loading="loadingAssignPrice"
                          :disabled="!(title && price)"
                          color="red-darken-1"
                          class="white--text ebay-shipping-btn"
                          @click="assignPrice"
                        >
                          {{
                            $t(
                              "leko_employees.ebay_shipping_price.assign_price",
                            )
                          }}
                        </v-btn>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-autocomplete
                        v-model="institution"
                        :items="institutions"
                        :loading="loadingInstitution"
                        :label="$t('parts.advanced_search.institution')"
                        :hint="$t('parts.advanced_search.institution')"
                        persistent-hint
                        item-title="title"
                        item-value="_id"
                        solo
                        color="red-darken-1"
                        class="mt-3 pt-2"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      sm="6"
                      class="d-flex align-end justify-end"
                    >
                      <v-btn
                        :loading="loadingAssignInstitutionPrice"
                        :disabled="!(institution && title)"
                        color="red-darken-1"
                        class="white--text ebay-shipping-btn"
                        @click="assignInstitutionPrice"
                      >
                        {{
                          $t(
                            "leko_employees.ebay_shipping_price.assign_institution_price",
                          )
                        }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>

              <v-col cols="12" lg="8">
                <v-container v-if="title" class="ebay-shipping-details-wrap">
                  <v-card class="pa-3 text-start ebay-shipping-details">
                    <div class="mb-2">
                      <h3>
                        {{
                          $t("leko_employees.ebay_shipping_price.title_details")
                        }}
                      </h3>
                    </div>
                    <div class="text-start mb-1 col-12">
                      <strong class="pt-1">partCode: </strong>
                      <a>{{ title.partCode }}</a>
                    </div>
                    <div class="text-start mb-1 col-12">
                      <strong class=""> ebayCategory: </strong>
                      <a>{{
                        title.ebayCategory ? title.ebayCategory.it : ""
                      }}</a>
                    </div>
                    <div class="text-start mb-1 col-12">
                      <strong> ebayCode: </strong>
                      <a>{{ title.ebayCode ? title.ebayCode : "" }}</a>
                    </div>
                    <div class="text-start mb-1 col-12">
                      <strong> ebayShippingReferencePrice: </strong>
                      <a>{{
                        title.ebayShippingReferencePrice
                          ? title.ebayShippingReferencePrice
                          : ""
                      }}</a>
                    </div>
                  </v-card>
                </v-container>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="loading" persistent content-class="ebay-shipping-loading">
      <v-card
        variant="outlined"
        color="transparent"
        class="d-flex align-center justify-center ebay-shipping-loading-card"
        transparent
      >
        <v-progress-circular color="#D32F2F" indeterminate size="100" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="success" max-width="300">
      <v-alert v-model="success" type="success" dismissible :value="true">
        {{ $t("institutions.form.success") }}
      </v-alert>
    </v-dialog>
    <v-dialog v-model="error" max-width="300">
      <v-alert v-model="error" type="error" dismissible :value="true">
        {{ $t("Error") }}
      </v-alert>
    </v-dialog>
  </v-container>
</template>

<script>
import getRequest from "../api/getRequest";
import putRequest from "../api/putRequest";

export default {
  data: () => ({
    searchTitle: null,
    loadingTitle: false,
    title: null,
    titles: [],
    price: 0,
    loadingAssignPrice: false,
    institution: null,
    institutions: [],
    loadingInstitution: false,
    loadingAssignInstitutionPrice: false,
    loading: false,
    code: null,
    category: null,
    success: false,
    error: false,
    menuOpen: false,
    selectingItem: false,
  }),
  watch: {
    async searchTitle(newValue) {
      if (this.selectingItem) {
        this.selectingItem = false;
        return;
      }
      if (newValue) {
        if (this.selectingItem) {
          this.selectingItem = false;
          return;
        }
        this.loadingTitle = true;
        try {
          const response = await getRequest(
            "/info-car/parts",
            `title=${encodeURIComponent(newValue)}&language=${this.$store.getters.language}`,
          );
          this.titles = response.parts || [];
        } catch (error) {
          this.titles = [];
        } finally {
          this.loadingTitle = false;
          this.menuOpen = this.titles.length > 0;
        }
      } else {
        if (!this.title) {
          this.titles = [];
          this.menuOpen = false;
        } else {
          const selected = this.titles.find((t) => t.partCode === this.title);
          if (selected) {
            this.selectingItem = true; // prevent re-trigger
            this.searchTitle =
              selected.title?.[this.$store.getters.language] || "";
            this.menuOpen = false;
          }
        }
      }
    },
    title: {
      handler(newTitle) {
        if (newTitle && newTitle.ebayCategory && newTitle.ebayCategory.it) {
          this.category = newTitle.ebayCategory.it;
        }
        if (newTitle && newTitle.ebayShippingReferencePrice) {
          this.price = newTitle.ebayShippingReferencePrice;
        }
      },
      deep: true,
    },
  },
  created() {
    this.getInstitutions();
  },
  methods: {
    assignPrice() {
      this.loadingAssignPrice = true;
      this.loading = true;
      putRequest("/ebay-shipping-price/global-price", "", {
        partCode: this.title.partCode,
        shippingPrice: this.price,
        ebayCode: this.title.ebayCode,
        ebayCategory: this.category,
      })
        .then((response) => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 3000);
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        })
        .finally(() => {
          this.loadingAssignPrice = false;
          this.loading = false;
        });
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          this.loadingInstitution = false;
        })
        .catch(() => {
          this.loadingInstitution = false;
        });
    },
    assignInstitutionPrice() {
      this.loadingAssignInstitutionPrice = true;
      this.loading = true;
      putRequest("/ebay-shipping-price/institution-price", "", {
        partCode: this.title.partCode,
        shippingPrice: this.price,
        institutionId: this.institution,
      })
        .then(() => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 3000);
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        })
        .finally(() => {
          this.loadingAssignInstitutionPrice = false;
          this.loading = false;
        });
    },
    selectCode(item) {
      this.title = item.raw;
      this.selectingItem = true;
    },
    highlight(title, search) {
      let result = title || "";
      if (search) {
        const index = title
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase());
        // mark the text.
        if (index > -1)
          result = [
            title.slice(0, index),
            "<mark>",
            title.slice(index, index + search.length),
            "</mark>",
            title.slice(index + search.length),
          ].join("");
      }
      return `<span>${result}</span>`;
    },
    customFilter(item, queryText, itemText) {
      if (!queryText) return true;
      const searchText = queryText.toLowerCase();
      const language = this.$store.getters.language;

      // Check main title
      const mainTitle = itemText.raw?.title?.[language]?.toLowerCase() || "";
      if (mainTitle.includes(searchText)) return true;

      // Check related titles
      // const relatedTitles = itemText.raw?.related || [];
      // return relatedTitles.some((related) => {
      //   const relatedTitle = related?.title?.[language]?.toLowerCase() || "";
      //   return relatedTitle.includes(searchText);
      // });
    },
  },
};
</script>
<style scoped>
.text-start {
  text-align: start !important;
}

.ebay-shipping-toolbar-title {
  line-height: 1.35;
  word-break: break-word;
}

.ebay-shipping-details a {
  word-break: break-word;
}

.ebay-shipping-loading-card {
  min-height: 200px;
  background: transparent;
  box-shadow: none;
}

@media (max-width: 959.98px) {
  .ebay-shipping-toolbar-title {
    font-size: 1rem;
    text-align: center;
  }

  .ebay-shipping-content {
    padding: 0 8px 16px;
  }

  .ebay-shipping-form,
  .ebay-shipping-details-wrap {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .ebay-shipping-btn {
    width: 100%;
    max-width: 100%;
    white-space: normal;
    height: auto;
    min-height: 36px;
  }

  .ebay-shipping-loading-card {
    min-height: 120px;
  }
}
</style>
